/** Shape of `useSpeechDictation()` — avoids importing the hook in a presentational file. */
export type DevConvoDictationApi = {
  isSupported: boolean;
  isListening: boolean;
  draft: string;
  error: string | null;
  start: () => void;
  stop: () => void;
};

export function DevConvoDictationSection(props: {
  dictation: DevConvoDictationApi;
  onConfirmAsk: () => void;
}) {
  const { dictation, onConfirmAsk } = props;

  return (
    <div className="bg-gray-50 border border-gray-200 rounded-2xl p-3 space-y-2">
      <div className="flex items-center justify-between">
        <div className="text-sm font-semibold min-w-0">Spoken prompt</div>
        {!dictation.isSupported && <div className="text-xs text-gray-500">Not supported in this browser</div>}
      </div>

      <div className="flex gap-2">
        <button
          type="button"
          className={`rounded-xl px-3 py-2 text-sm font-semibold ${
            dictation.isSupported && !dictation.isListening ? "bg-black text-white" : "bg-gray-200 text-gray-500 cursor-not-allowed"
          }`}
          disabled={!dictation.isSupported || dictation.isListening}
          onClick={() => dictation.start()}
        >
          Dictate
        </button>

        <button
          type="button"
          className={`rounded-xl px-3 py-2 text-sm font-semibold ${
            dictation.isListening ? "bg-black text-white" : "bg-gray-200 text-gray-500 cursor-not-allowed"
          }`}
          disabled={!dictation.isListening}
          onClick={dictation.stop}
        >
          Stop
        </button>

        <button
          type="button"
          className={`rounded-xl px-3 py-2 text-sm font-semibold ${
            dictation.draft.trim() ? "bg-white border border-gray-300" : "bg-gray-200 text-gray-500 cursor-not-allowed"
          }`}
          disabled={!dictation.draft.trim()}
          onClick={onConfirmAsk}
        >
          Confirm → Ask
        </button>
      </div>

      {dictation.error && (
        <div className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-xl p-2">Dictation error: {dictation.error}</div>
      )}

      {dictation.draft.trim() && (
        <div className="text-sm bg-white border border-gray-200 rounded-xl p-2">
          <div className="text-xs text-gray-500 mb-1">Heard</div>
          <div className="whitespace-pre-wrap">{dictation.draft}</div>
          <div className="text-xs text-gray-500 mt-2">Confirm to ask and populate the answer field automatically.</div>
        </div>
      )}
    </div>
  );
}
